// iOS Safari 兼容性 polyfills

// requestIdleCallback polyfill for iOS Safari
if (!window.requestIdleCallback) {
    window.requestIdleCallback = function(callback, options = {}) {
        const timeout = options.timeout || 0;
        const startTime = performance.now();
        
        return setTimeout(() => {
            callback({
                didTimeout: false,
                timeRemaining() {
                    return Math.max(0, 50 - (performance.now() - startTime));
                }
            });
        }, timeout);
    };
}

// cancelIdleCallback polyfill
if (!window.cancelIdleCallback) {
    window.cancelIdleCallback = function(id) {
        clearTimeout(id);
    };
}

// 檢測 iOS 設備
export const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

// 檢測 Safari 瀏覽器
export const isSafari = () => {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

// WebSocket 兼容性檢查
export const checkWebSocketSupport = () => {
    if (!window.WebSocket) {
        console.error('WebSocket is not supported in this browser');
        return false;
    }
    return true;
};

// 為 iOS 設備優化的 WebSocket 配置
export const getWebSocketConfig = () => {
    const config = {};
    
    if (isIOS()) {
        // iOS 設備的特殊配置
        config.protocols = [];
        config.binaryType = 'arraybuffer';
    }
    
    return config;
};

console.log('Polyfills loaded for iOS compatibility'); 